module.exports = __webpack_public_path__ + "static/img/banner4-反欺诈.1912c40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner4-反欺诈.jpg
// module id = HSYd
// module chunks = 1